import type { Organization } from '@/types/organization'
import type { AuditFields } from '@/types/journey-products'
import type { Customer } from '@/types/nest/customer'
import type { UUID } from 'crypto'

export type ExtraOptions = Record<string, unknown>

/**
 * A single permission on a role.
 */
export type Permission = {
  id: number
  createdDate: string
  lastModifiedDate: string
  createdBy: string | null
  extraOptions: unknown | null
  createdByOrganisation: unknown | null
  lastModifiedBy: string | null
  deleted: boolean
  syncindex: string
  entity: string
  type: string
}

/**
 * A role assigned to the user.
 */
export type Role = {
  id: number
  createdDate: string | null
  lastModifiedDate: string | null
  organisatieId: number | null
  userId: number | null
  createdBy: string | null
  lastModifiedBy: string | null
  deleted: boolean
  name: string
  permissions: Permission[]
  subModuleAuthorities: unknown[]
}

/**
 * The user object.
 */
export type LzpUser = {
  userOrganisatie: Organization
  extraOptions: ExtraOptions
  email: string
  createdDate: string
  blocked: boolean | null
  userUUID: string
  externalId: string | null
  firstName: string
  lastName: string
  username: string
  roles: Role[]
  modules: number[]
  password: string | null
}

/**
 * A more complete user object.
 */
export type User = AuditFields & {
  id: number
  extraOptions: Record<string, unknown>
  userUUID: string
  username: string
  firstName: string
  lastName: string
  email: string
  refreshToken: string
  userOrganisatie: Organization
  enabled: boolean
  credentialsNonExpired: boolean
  accountNonExpired: boolean
  accountNonLocked: boolean
}

export type CreateUser = {
  email: string
  firstName: string
  lastName: string
  role: NestUserRole
}

/**
 * A nest me user object.
 */
export type NestUser = {
  id: UUID
  customerId: UUID
  email: string
  firstName: string
  lastName: string
  role: NestUserRole
  permissions: []
  customer: Customer
}

export enum NestUserRole {
  ADMIN = 'admin',
  OWNER = 'owner',
  USER = 'user',
  VIEWER = 'viewer',
}
